import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { alignItems, color, display } from 'styled-system';

const UnstyledListItem = styled.li<any>`
  ${color};
  ${display};
  ${alignItems};
`;

const ListItem = (props: ComponentProps<typeof UnstyledListItem>) => (
  <UnstyledListItem
    alignItems="center"
    display="inline-flex"
    color="sys.neutral.border.strong"
    {...props}
  />
);

export default ListItem;
